<div class="c-routes" data-view="card">
    <div class="c-routes__scrollable">
        <div class="u-push-t u-push-b u-align-center">
            <core-generic-button [config]="{ 
                    text: 'voyage.addPortCall' | translate, 
                    type: buttonTypes.PRIMARY, 
                    icon: 'icon-add' 
                }" (buttonClick)="onAddPortCall() 
            " />
        </div>
    </div>
</div>